<template>
    <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input"
               :id="id" :value="!!value"
               @change="$emit('input', $event.target.checked)">
        <label class="custom-control-label" :for="id" v-text="label"/>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.id = 'checkbox_' + Math.round(Math.random() * 990000);
        },
        props: ['value', 'label'],
        data() {
            return {
                id: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/colors.scss";

    .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
        border-color: $lightGrey !important;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
        border-color: $mediumGrey !important;
        background-color: $mediumGrey !important;
    }

    .custom-control {
        padding-left: 2rem !important;

        .custom-control-label {
            &::before, &::after {
                width: 1.5rem;
                height: 1.5rem;
                top: 0.1rem;
                left: -2rem;
            }

            &::before {
                border: $lightGrey solid 2px;
                box-shadow: none !important;
            }
        }
    }
</style>
